/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiPetV2FormField,
  ApiPetV2FormFieldFromJSON,
  ApiPetV2FormFieldFromJSONTyped,
  ApiPetV2FormFieldToJSON,
} from './ApiPetV2FormField';

/**
 *
 * @export
 * @interface ApiPetV2FormSection
 */
export interface ApiPetV2FormSection {
  /**
   *
   * @type {string}
   * @memberof ApiPetV2FormSection
   */
  heading: string;
  /**
   *
   * @type {string}
   * @memberof ApiPetV2FormSection
   */
  subHeading?: string;
  /**
   *
   * @type {string}
   * @memberof ApiPetV2FormSection
   */
  icon?: ApiPetV2FormSectionIconEnum;
  /**
   * this is meant to control the order the section is displayed on the client
   * @type {number}
   * @memberof ApiPetV2FormSection
   */
  order: number;
  /**
   *
   * @type {Array<ApiPetV2FormField>}
   * @memberof ApiPetV2FormSection
   */
  formFields: Array<ApiPetV2FormField>;
}

/**
 * @export
 */
export const ApiPetV2FormSectionIconEnum = {
  Award: 'award',
  Close: 'close',
  Expert: 'expert',
  Pharmacy: 'pharmacy',
  Time: 'time',
  Truck: 'truck',
  Birthday: 'birthday',
  Box: 'box',
  ConnectWithAVetDesktop: 'connect-with-a-vet-desktop',
  ConnectWithAVetMobile: 'connect-with-a-vet-mobile',
  Gift: 'gift',
  HeartFill: 'heart-fill',
  HouseClinic: 'house-clinic',
  HouseShelter: 'house-shelter',
  Note: 'note',
  PrescriptionBottle: 'prescription-bottle',
  Storefront: 'storefront',
  Tag: 'tag',
} as const;
export type ApiPetV2FormSectionIconEnum = typeof ApiPetV2FormSectionIconEnum[keyof typeof ApiPetV2FormSectionIconEnum];

export function ApiPetV2FormSectionFromJSON(json: any): ApiPetV2FormSection {
  return ApiPetV2FormSectionFromJSONTyped(json, false);
}

export function ApiPetV2FormSectionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiPetV2FormSection {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    heading: json['heading'],
    subHeading: !exists(json, 'subHeading') ? undefined : json['subHeading'],
    icon: !exists(json, 'icon') ? undefined : json['icon'],
    order: json['order'],
    formFields: (json['formFields'] as Array<any>).map(ApiPetV2FormFieldFromJSON),
  };
}

export function ApiPetV2FormSectionToJSON(value?: ApiPetV2FormSection | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    heading: value.heading,
    subHeading: value.subHeading,
    icon: value.icon,
    order: value.order,
    formFields: (value.formFields as Array<any>).map(ApiPetV2FormFieldToJSON),
  };
}
